import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

// constants
import { app } from 'config/app.config';

// components
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-demo-call-to-action',
  templateUrl: './demo-call-to-action.html',
  styleUrl: './demo-call-to-action.scss',
  imports: [
    ButtonModule,
    RouterLink,
  ],
})
export class DemoCallToAction {

  // component
  appName: string = app.marketing.names.product;

  contactQueryParams = {
    subject: 'Demo Request',
    body: `I would like to request a demo of ${this.appName}, to explore all the features and functionality it has to offer.`,
  };

}
